export var MESSAGE_STATUS;
(function (MESSAGE_STATUS) {
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_SENT"] = 0] = "MESSAGE_SENT";
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_ACCEPTED"] = 1] = "MESSAGE_ACCEPTED";
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_DELIEVERED"] = 2] = "MESSAGE_DELIEVERED";
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_SEEN"] = 3] = "MESSAGE_SEEN";
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_FAILED"] = 4] = "MESSAGE_FAILED";
    MESSAGE_STATUS[MESSAGE_STATUS["CHANNEL_FAILED"] = 5] = "CHANNEL_FAILED";
    MESSAGE_STATUS[MESSAGE_STATUS["MESSAGE_DELETED"] = 6] = "MESSAGE_DELETED";
})(MESSAGE_STATUS || (MESSAGE_STATUS = {}));
export var MEDIA_TYPE;
(function (MEDIA_TYPE) {
    MEDIA_TYPE["IMAGE"] = "image";
    MEDIA_TYPE["DOC"] = "document";
    MEDIA_TYPE["AUDIO"] = "audio";
    MEDIA_TYPE["VIDEO"] = "video";
    MEDIA_TYPE["STICKER"] = "sticker";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
export var MESSAGE_DIRECTION;
(function (MESSAGE_DIRECTION) {
    MESSAGE_DIRECTION["IN"] = "incoming";
    MESSAGE_DIRECTION["OUT"] = "outgoing";
})(MESSAGE_DIRECTION || (MESSAGE_DIRECTION = {}));
export var MessageContentsType;
(function (MessageContentsType) {
    MessageContentsType["text"] = "text";
    MessageContentsType["media"] = "media";
    MessageContentsType["contacts"] = "contacts";
    MessageContentsType["location"] = "location";
    MessageContentsType["buttons"] = "buttons";
    MessageContentsType["list"] = "list";
    MessageContentsType["postback"] = "postback";
    MessageContentsType["special"] = "special";
})(MessageContentsType || (MessageContentsType = {}));
/**
 * This enum added for different cases when we need to show message status in human friendly way,
 * and to avoid changing existing legacy MESSAGE_STATUS enum, which may require too much changes.
 */
export var MessageStatusHumanfriendly;
(function (MessageStatusHumanfriendly) {
    MessageStatusHumanfriendly["Sent"] = "Sent";
    MessageStatusHumanfriendly["Accepted"] = "Accepted";
    MessageStatusHumanfriendly["Delivered"] = "Delivered";
    MessageStatusHumanfriendly["Seen"] = "Seen";
    MessageStatusHumanfriendly["Failed"] = "Failed";
    MessageStatusHumanfriendly["ChannelFailed"] = "Channel Failed";
    MessageStatusHumanfriendly["Deleted"] = "Deleted";
})(MessageStatusHumanfriendly || (MessageStatusHumanfriendly = {}));
export const MESSAGE_STATUS_HUMAN_FRIENDLY_MAP = Object.freeze({
    [MESSAGE_STATUS.MESSAGE_SENT]: MessageStatusHumanfriendly.Sent,
    [MESSAGE_STATUS.MESSAGE_ACCEPTED]: MessageStatusHumanfriendly.Accepted,
    [MESSAGE_STATUS.MESSAGE_DELIEVERED]: MessageStatusHumanfriendly.Delivered,
    [MESSAGE_STATUS.MESSAGE_SEEN]: MessageStatusHumanfriendly.Seen,
    [MESSAGE_STATUS.MESSAGE_FAILED]: MessageStatusHumanfriendly.Failed,
    [MESSAGE_STATUS.CHANNEL_FAILED]: MessageStatusHumanfriendly.ChannelFailed,
    [MESSAGE_STATUS.MESSAGE_DELETED]: MessageStatusHumanfriendly.Deleted,
});
